module.exports = __webpack_public_path__ + "media/images/_anim3-ea9c19c490fe7a42ddb37aaba3724262.gif";